var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V17C22 20 20 22 17 22H7C4 22 2 20 2 17V12C2 9.28 3.64 7.38 6.19 7.06C6.45 7.02 6.72 7 7 7H17C17.26 7 17.51 7.01 17.75 7.05C20.33 7.35 22 9.26 22 12Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 12.5H18.9999C17.8999 12.5 16.9999 13.4 16.9999 14.5C16.9999 15.6 17.8999 16.5 18.9999 16.5H21.9999M17.7509 7.04996C17.5109 7.00996 17.2609 6.99996 17.0009 6.99996H7.00092C6.72092 6.99996 6.45092 7.01996 6.19092 7.05996C6.33092 6.77996 6.53092 6.51996 6.77092 6.27996L10.0209 3.01996C10.6809 2.36654 11.5722 2 12.5009 2C13.4297 2 14.3209 2.36654 14.9809 3.01996L16.7309 4.78996C17.3709 5.41996 17.7109 6.21996 17.7509 7.04996Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningManager);
export default __webpack_public_path__ + "static/media/earning_manager.63b3f992b59ec1a861831dba1c8271f8.svg";
export { ForwardRef as ReactComponent };